<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :table-config-options="{ endpoint: `${MODULE_NAME}/listView`, data: { id: $route.params.id }}"
  >
    <template #cell(reason_status)="{data}">
      <b-badge :variant="getReasonStatus(data.value).color">
        {{ $langName(getReasonStatus(data.value)) }}
      </b-badge>
    </template>
    <template #cell(status)="{data}">
      <b-badge :variant="getStatus(data.value).color">
        {{ $langName(getStatus(data.value)) }}
      </b-badge>
    </template>

    <template #cell(actions)="{data}">
      <div class="text-nowrap">
        <feather-icon
          icon="TrashIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import config from './config'
import LTable from '@/views/components/LTable.vue'

export default {
  name: 'CheckMonitoring',
  components: {
    LTable,
    BBadge,
  },
  methods: {
    getStatus(statusCode) {
      return this.$store.getters['staticModule/getCheckMonitoringStatusCheckStatus'](statusCode)
    },
    getReasonStatus(statusReasonCode) {
      return this.$store.getters['staticModule/getCheckMonitoringReasonStatusCheckStatus'](statusReasonCode)
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, () => {
        this.$emit('delete')
        this.$refs.LTable.refetchData()
      })
    },
  },
  setup() {
    const MODULE_NAME = 'checkMonitoring'
    return {
      MODULE_NAME,
      ...config(MODULE_NAME),
    }
  },
}
</script>

<style scoped>

</style>
